import { useMemo, type CSSProperties } from "react";
import { useTheme } from "@repo/tokens";

export type BreadcrumbStyles = {
  container: CSSProperties;
  list: CSSProperties;
  item: CSSProperties;
  separator: CSSProperties;
  link: CSSProperties;
  active: CSSProperties;
};

export const useBreadcrumbStyles = (): BreadcrumbStyles => {
  const { theme } = useTheme();
  const typography = theme.typography.title.medium.regular;

  return useMemo(
    () => ({
      container: {
        display: "flex",
        alignItems: "center",
        flex: 1,
      },
      list: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing.sm,
        listStyle: "none",
        margin: 0,
        padding: 0,
      },
      item: {
        display: "flex",
        alignItems: "center",
        color: theme.colors.primary[40],
        whiteSpace: "nowrap",
        verticalAlign: "middle",
      },
      active: {
        color: theme.colors.primary[20],
      },
      separator: {
        margin: 0,
        color: theme.colors.primary[80],
      },
      link: {
        cursor: "pointer",
        textDecoration: "none",
        color: theme.colors.primary[40],
        fontWeight: theme.typography.body.large.emphasized.fontWeight,
      },
    }),
    [theme, typography],
  );
};
